package one.healthium.featureconfig.di

import one.healthium.featureconfig.data.FirebaseFeatureConfigRepository
import one.healthium.featureconfig.domain.CoreFeatureConfigSchema
import one.healthium.featureconfig.domain.FeatureConfigInteractor
import one.healthium.featureconfig.domain.FeatureConfigRepository
import one.healthium.featureconfig.domain.FeatureConfigSchema
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val featureConfigModule = module {
    single { CoreFeatureConfigSchema as FeatureConfigSchema }
    singleOf(::FirebaseFeatureConfigRepository) bind FeatureConfigRepository::class
    factoryOf(::FeatureConfigInteractor)
}
